import { render, staticRenderFns } from "./EdsEdit.vue?vue&type=template&id=4ae3cdb5&"
import script from "./EdsEdit.vue?vue&type=script&lang=js&"
export * from "./EdsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports